//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

//css
import styled from "styled-components";

// component
import MemOut from "./components/MemOut";

export default function MemOutPage() {
    return <MemOut />;
}
